"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelQualityScale = props => {
  const {
    className = '',
    label = '',
    options = [],
    value,
    hideSelLabel = false
  } = props;
  const selectedOpt = options.find(item => item.value === value);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-quality-static-container ${className}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label mb-0"
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f"
  }, options.map((val, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `opt_${i.toString()}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `step ${value <= val.value ? 'activeBack' : ''}`
  }))))), !hideSelLabel && (/*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r h-fix-32 dis-f a-c"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "fsize-300 fweight-500"
  }, selectedOpt && selectedOpt.label)))));
};
var _default = exports.default = BrixelQualityScale;